import Link from "next/link";
import dayjs from "dayjs";
import S from "./index.module.scss";
import { FC } from "react";
import "dayjs/locale/ru";
import { NewsListResourceData } from "@/api/generated-api";
import Picture from "@/components/ui/picture";
import CustomIcon from "@/components/ui/custom-icon";

dayjs.locale("ru");

const NewsCard: FC<{ news: NewsListResourceData }> = ({ news }) => {
  return (
    <Link key={news.id} className={S.news} href={`/news/${news.id}`}>
      <Picture alt={news.title} width={800} height={300} image={news.preview_image} />
      <div className={S.textWrapper}>
        <span className={S.newsTitle}>{news.title}</span>
        <span className={S.newsDescription} dangerouslySetInnerHTML={{ __html: news?.description }} />
        <div className={S.newsBottom}>
          <span className={S.newsDate}>{dayjs(news.date).format("DD MMMM YYYY")}</span>
          <CustomIcon fileName={"icon-arrow-long"} />
        </div>
      </div>
    </Link>
  );
};

export default NewsCard;
